
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Home, Save } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DivergenceDisplayProps {
  user: any;
  onSignInToSave: () => void;
}

export const DivergenceDisplay = ({ user, onSignInToSave }: DivergenceDisplayProps) => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="text-center p-8 bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-900 dark:to-gray-800 rounded-lg shadow-lg animate-fadeIn" 
      initial={{ scale: 0.8, opacity: 0 }} 
      animate={{ scale: 1, opacity: 1 }} 
      transition={{ type: "spring", stiffness: 200, damping: 20, duration: 0.6 }}
    >
      <motion.h2 
        className="text-3xl font-bold text-foreground mb-4" 
        initial={{ y: -20 }} 
        animate={{ y: 0 }} 
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        🤖 Divergence!
      </motion.h2>
      
      <motion.p 
        className="text-xl mb-6 text-muted-foreground" 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        transition={{ delay: 0.6, duration: 0.5 }}
      >
        You reached 20 rounds without finding a common word.
      </motion.p>
      
      <motion.div 
        initial={{ scale: 0 }} 
        animate={{ scale: 1 }} 
        transition={{ delay: 0.9, type: "spring", stiffness: 200 }} 
        className="flex flex-col sm:flex-row gap-3 justify-center items-center"
      >
        <Button 
          size="lg" 
          onClick={() => navigate("/")} 
          className="bg-primary/90 hover:bg-primary transition-colors duration-300 flex items-center gap-2 opacity-80"
        >
          <Home className="w-4 h-4" />
          Return Home
        </Button>
        
        {!user && (
          <Button 
            size="lg" 
            variant="outline" 
            onClick={onSignInToSave} 
            className="flex items-center gap-2"
          >
            <Save className="w-4 h-4" />
            Sign in to save your results
          </Button>
        )}
      </motion.div>
    </motion.div>
  );
};
